import { Actions } from '../../interfaces'
import { Price } from '@/entities/sales'

import find from './find'
import fetch from './fetch'
import update from './update'
import create from './create'

export const actions: Actions = {
  find,
  fetch,
  update,
  create,
}

export default {
  Model: { Price },
  actions: { [Price.name]: actions },
}
